// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container__src-labstep-web-core-PremiumFeature-LockIcon-_qXw9o","shiny":"styles-module__shiny__src-labstep-web-core-PremiumFeature-LockIcon-_Zc3uz"};